/*
 *
 * CollaboratorsEdit constants
 *
 */
export const GET_LANGUAGE_WATCHER = "app/CollaboratorsEdit/GET_LANGUAGE_WATCHER"
export const GET_LANGUAGE_SUCCESS = "app/CollaboratorsEdit/GET_LANGUAGE_SUCCESS"
export const GET_LANGUAGE_FAILED = "app/CollaboratorsEdit/GET_LANGUAGE_FAILED"

export const GET_COLLABORATOR_INFO_WATCHER =
  "app/CollaboratorsEdit/GET_COLLABORATOR_INFO_WATCHER"
export const GET_COLLABORATOR_INFO_SUCCESS =
  "app/CollaboratorsEdit/GET_COLLABORATOR_INFO_SUCCESS"
export const GET_COLLABORATOR_INFO_FAILED =
  "app/CollaboratorsEdit/GET_COLLABORATOR_INFO_FAILED"
export const UPDATE_COLLABORATOR_WATCHER =
  "app/CollaboratorsEdit/UPDATE_COLLABORATOR_WATCHER"
export const UPDATE_COLLABORATOR_SUCCESS =
  "app/CollaboratorsEdit/UPDATE_COLLABORATOR_SUCCESS"
export const REMOVE_COLLABORATOR_WATCHER =
  "app/CollaboratorsEdit/REMOVE_COLLABORATORS_WATCHER"
export const REMOVE_COLLABORATOR_SUCCESS =
  "app/CollaboratorsEdit/REMOVE_COLLABORATORS_WATCHER"

export const GET_MEASURES_WATCHER = "app/CollaboratorsEdit/GET_MEASURES_WATCHER"
export const GET_MEASURES_SUCCESS = "app/CollaboratorsEdit/GET_MEASURES_SUCCESS"
export const GET_MEASURES_FAILED = "app/CollaboratorsEdit/GET_MEASURES_FAILED"
